import Focus from '../../Images/Home/Focus.png';
import Strength from '../../Images/Home/strength.png';
import Expertise from '../../Images/Home/Expertise.png';

const Content =[
    {
        id:1,
        image: Focus,
        alt:"Focus",
        title:"Our Focus",
        text:"Our focus is you. We strive to understand your technology and transformation goals and deliver solutions that exceed your expectations. We are focused on building relationships and providing you with the solutions you need to succeed."
        
    },
    {
        id:2,
        image: Strength,
        alt:"Strength",
        title:"Our Strength",
        text:"We are powered by a team of  versatile skills, experienced, passionate professionals and driven by streamlined, robust, agile processes. Our strength is in our ability to adapt to change, solve complex problems, deliver projects on time and within budget."
        
    },
    {
        id:3,
        image: Expertise,
        alt:"Expertise",
        title:"Our Expertise",
        text:"With years of experience and a commitment to staying at the forefront of technology, we possess the expertise to  navigate complex challenges, implement cutting-edge technologies, develop innovative strategies for technology adop. Our expertise is your advantage."
        
    },
  
];
export default Content;
